import { z } from 'zod';
import { PartnerContactSchema } from '../../entities/partner/partner-contact.schema';
import { optionalEmailSchema } from '../../../../shared/email.schema';
import { ErrorCode } from '../../../../shared/error-codes';
const optionalText = ()=>z.string().trim().transform((v)=>v === '' ? undefined : v).optional();
/**
 * Create Partner Contact Request
 * POST /api/v2/partner/contacts
 */ export const CreatePartnerContactRequestSchema = z.object({
    firstName: z.string().trim().min(1, ErrorCode.FIELD_REQUIRED),
    lastName: z.string().trim().min(1, ErrorCode.FIELD_REQUIRED),
    email: optionalEmailSchema(),
    phone: optionalText(),
    company: z.string().trim().min(1, ErrorCode.FIELD_REQUIRED),
    note: optionalText()
});
export const CreatePartnerContactResponseSchema = z.object({
    data: PartnerContactSchema
});

//# sourceMappingURL=create-partner-contact.schema.js.map